import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { Form } from 'react-bootstrap';
import { SERVER_URL } from './ServerConfig';

export default class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectToDashoard: false,
            email: '',
            loginContent: {},
            validated: false,
            message: '',
            isEmailSent: false,
            isSendingEmail: false
        };
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    getEmailMessage() {
        return 'An email has been sent to ' + this.state.email + '. Please check your inbox to continue resetting password.'
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.email) {
            this.setState({ validated: true });
            return;
        }
        this.setState({ isSendingEmail: true })
        fetch(SERVER_URL + '/v1/users/resetPassword', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: this.state.email
            })
        }).then(response => response.json())
            .then(data => {
                if (data.success === true) {
                    this.setState({ isSendingEmail: false, message: this.getEmailMessage(), isEmailSent: true })
                } else {
                    this.setState({ isSendingEmail: false, message: data.message });
                }
            }).catch(err => {
                this.setState({ message: "Server is in maintenance" });
            });
    }

    renderSubmitButton() {
        if (this.state.isSendingEmail) {
            return (<button type="submit" className="btn btn-primary btn-block" disabled>
                <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                Request new password...
            </button>);
        } else {
            return (<button type="submit" className="btn btn-primary btn-block">Request new password</button>);
        }
    }

    renderMessage() {
        if (this.state.isEmailSent) {
            return (
                <div className="col-12">
                    <div className="alert alert-success alert-dismissible fade show">
                        <i className="icon fas fa-check"></i>{this.state.message}
                    </div>
                    <p className="mt-2 mb-1">
                        Back to
                        <a href="/login"> Login </a>page
                    </p>
                </div>
            )
        }
        return (
            <div className="col-12">
                <p className="login-box-msg mt-2">You forgot your password? Here you can easily retrieve a new password.</p>
                <div className="text-center">
                    <p className="text-danger">{this.state.message}</p>
                </div>
                <Form onSubmit={this.handleSubmit} validated={this.state.validated}>
                    <Form.Row>
                        <Form.Group controlId="validationCustom01" className="input-group mb-3">
                            <Form.Control
                                required
                                type="email"
                                placeholder="Email"
                                value={this.state.email}
                                onChange={this.handleEmailChange}
                            />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                    <span className="fas fa-envelope"></span>
                                </div>
                            </div>
                            <Form.Control.Feedback type="invalid">Email cannot be empty</Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    <div className="row">
                        {this.renderSubmitButton()}
                    </div>
                </Form>
                <p className="mt-2 mb-1">
                    <a href="/login">Login</a>
                </p>
            </div>
        )
    }

    render() {
        if (this.state.redirectToDashoard) {
            return <Redirect to={{
                pathname: "/dashboard"
            }} />
        }
        return (
            <div className="hold-transition login-page">
                <div className="bg-image" />
                <div className="reset-box">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-center">
                                <h2><b>Solar </b>Monitoring</h2>
                            </div>
                            {this.renderMessage()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}